<template>
  <div class="content">
    <div class="title">
      <div class="nightPk">晚间PK场</div>
      <div class="pkDate" v-if="isToday">{{ nowDate }}</div>
      <div class="pkDate" v-if="!isToday">
        {{ this.pkParams.date.slice(0, 10) }}
      </div>
    </div>
    <div class="pkContent">
      <ul class="pkHead">
        <li>姓名</li>
        <li>学科</li>
        <li class="segContent">
          <div>局数</div>
          <div class="segContenttext">段位赛/单人</div>
        </li>
        <li class="segContent">
          <div>奖杯数</div>
          <div class="segContenttext">段位赛/单人</div>
        </li>
      </ul>
      <div class="pkListContent">
        <ul class="pkList" v-for="(item, index) in pkList" :key="index">
          <li class="pkListItem">
            <div class="realName">{{ item.real_name }}</div>
            <div class="account">{{ item.uname }}</div>
          </li>
          <li class="pkListItem">{{ item.subject_text }}</li>
          <li class="pkListItem segContent">
            {{ item.segment_pk_count }}/{{ item.alone_pk_count }}
          </li>
          <li class="pkListItem segContent">
            {{ item.segment_pk_score }}/{{ item.alone_pk_score }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import HomeTitleBar from "@views/WinterGame/components/homeTitleBar.vue";
import { queryPkDetails } from "../../api/winterGame";
import { getNowFormatDate } from "@/util/util";
import { Toast } from "vant";

export default {
  name: "",
  components: {
    HomeTitleBar,
  },
  computed: {},
  props: {},
  data() {
    return {
      pkParams: "",
      isToday: "",
      nowDate: "",
      currentCampusId: 0, //当前代理商id
      seasonId: "", //赛季id为空默认当季赛
      date: "", //历史查询日期
      pkList: [],
    };
  },
  watch: {},
  methods: {
    async queryPkDetails() {
      let params = {
        param: {
          currentCampusId: this.pkParams.currentCampusId,
          // currentCampusId: 128, //测试环境数据 0831,128
          seasonId: this.pkParams.seasonId,
          date: this.isToday ? "" : this.pkParams.date,
        },
      };
      let res = await queryPkDetails(params);
      // res = {
      //   code: 0,
      //   message: "",
      //   data: [
      //     {
      //       segment_pk_count: 5,
      //       account_id: "8887177758906937",
      //       alone_pk_count: 0,
      //       uname: "syx5211niutiti",
      //       subject_text: "数学",
      //       segment_pk_score: 11386,
      //       real_name: "牛踢踢测试账号长度专",
      //       alone_pk_score: 0,
      //     },
      //     {
      //       segment_pk_count: 5,
      //       account_id: "8887177758906937",
      //       alone_pk_count: 0,
      //       uname: "syx5211niutiti",
      //       subject_text: "数学",
      //       segment_pk_score: 11386,
      //       real_name: "牛踢踢测试账号长度专",
      //       alone_pk_score: 0,
      //     },
      //     {
      //       segment_pk_count: 5,
      //       account_id: "8887177758906937",
      //       alone_pk_count: 0,
      //       uname: "syx5211niutiti",
      //       subject_text: "数学",
      //       segment_pk_score: 11386,
      //       real_name: "牛踢踢测试账号长度专",
      //       alone_pk_score: 0,
      //     },
      //   ],
      // };
      if (res.code == 0) {
        if (res.data.length == []) {
          Toast("暂无PK信息");
        } else {
          this.pkList = res.data;
        }
      }
    },
  },
  created() {
    this.nowDate = getNowFormatDate();
    this.pkParams = JSON.parse(localStorage.getItem("pkParams"));
    this.isToday = this.$route.query.flag == "today" ? true : false;
  },
  mounted() {
    this.queryPkDetails();
  },
};
</script>

<style lang="less" scoped>
.content {
  position: absolute;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #6b3410 0%, #875c31 100%);
  padding: 20px 0 30px;
  overflow: scroll;
  .title {
    display: flex;
    height: 88px;
    font-size: 40px;
    justify-content: space-evenly;
    line-height: 88px;
    background: url("../../assets/images/squirrelCup/2023/autumn/barBg.png")
      no-repeat;
    background-size: 100%;
    color: #fff0a7;
    padding: 0 120px;
    .pkDate {
      color: #fff;
      font-size: 28px;
    }
  }
}
.pkContent {
  text-align: center;
  margin: 40px 8px 0;
  background-image: linear-gradient(#bb8542, #eed890);
  border-radius: 8px;
  padding-bottom: 10px;
  ul li {
    text-align: center;
    width: 80px;
  }
  .pkHead {
    margin: 30px;
    display: flex;
    justify-content: space-evenly;
    color: #ffffff;
    font-size: 28px;
    height: 70px;
    line-height: 80px;
    padding-top: 10px;
    li {
      &:first-child {
        width: 150px;
      }
      &.segContent {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        height: 40px;
        line-height: 40px;
        width: 120px;
        text-align: center;
        .segContenttext {
          font-size: 22px;
          transform: scale(0.9);
        }
      }
    }
  }

  .pkListContent {
    .pkList:first-child {
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
    }
    .pkList:last-child {
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      margin-bottom: 10px;
    }
    .pkList {
      margin: -1px 18px;
      background: #ffffff;
      display: flex;
      justify-content: space-evenly;
      font-size: 28px;
      position: relative;
      padding-top: 10px;
      &::after {
        content: "";
        position: absolute;
        left: 50%; //居中
        transform: translateX(-50%);
        bottom: 0;
        width: 80%;
        height: 2px !important;
        background-color: #dee5f0;
      }
      &:first-child {
        &::after {
          height: 1px;
        }
      }
      &:last-child {
        &::after {
          height: 0;
        }
      }
      .segContent {
        width: 120px;
      }

      .pkListItem {
        height: 100px;
        line-height: 100px;
        .realName {
          width: 100px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .account {
          // white-space: nowrap;
          // overflow: hidden;
          // text-overflow: ellipsis;
          color: #68707d;
          font-size: 22px;
          transform: scale(0.9);
          width: 200px;
          word-wrap: break-word;
          line-height: 30px;
        }
        &:first-child {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          height: 40px;
          line-height: 40px;
          text-align: center;
          width: 150px;
          padding: 5px 0;
        }
      }
    }
  }
}
</style>
